import { makeStyles } from '@material-ui/core/styles'

const ListingStyles = makeStyles((theme) => ({
  listing: (props: { columns: number }) => ({
    // columnCount: props.columns,
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: theme.spacing(2),
    justifyContent: 'space-between',
    // alignItems: 'center',
    '& > div': {
      pageBreakInside: 'avoid',
      width: '30%',
    },
  }),
  listing2: {
    margin: theme.spacing(3.5, 0, 0, 0),
    columnCount: 1,
    [theme.breakpoints.up(768)]: {
      columnCount: 2,
    },
    [theme.breakpoints.up(1024)]: {
      columnCount: 3,
    },
  },
  loadMore: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: theme.spacing(4),
    '& hr': {
      width: '36%',
      border: 'none',
      height: 1,
      backgroundColor: '#979797',
    },
    '& button': {
      border: '1px solid #333333',
      borderRadius: 3,
      backgroundColor: '#333333',
      color: 'white',
      fontWeight: 600,
      padding: '15px 43.5px',
      boxShadow: '0 2px 8px 2px rgba(0,0,0,0.1)',
      fontFamily: theme.typography.fontFamily,
      fontSize: 14,
    },
  },
  loadMoreNoMargin: {
    marginBottom: 0,
  },
}))
export default ListingStyles
